import React from 'react';
import styles from './ResourceDetails.module.scss';

import {Song} from '../../../../../types';
import {ResourceMetadata, ResourceButtons} from './components';
import {SongList} from '../SongList';
import {useObsidianContext} from '../../../../../context/ObsidianProvider';

export type ResourceTypes = 'album' | 'playlist';

interface Props {
  type: ResourceTypes;
  id: string;
  name: string;
  creatorName: string;
  artwork: string;
  tracks: Song[];
  trackCount: number;
  likes: number;
  ordered?: boolean;
  onPlay(): void;
}
export function ResourceDetails(props: Props) {
  const {type} = props;
  const {obsidian} = useObsidianContext();

  const songSelectHandler = (song: Song) => {
    obsidian.play(song);
  };

  return (
    <div className={styles.ViewContainer}>
      <div className={styles.HeaderContainer}>
        <div>
          <img
            src={props.artwork}
            width="225"
            height="225"
            alt="resource cover"
            className={styles.Artwork}
          />
        </div>
        <div className={styles.ResourceData}>
          <div className={styles.ResourceMetadata}>
            <ResourceMetadata {...props} />
          </div>
          <div>
            <ResourceButtons {...props} liked={false} />
          </div>
        </div>
      </div>
      <SongList
        ordered={props.ordered}
        type={type}
        songs={props.tracks}
        onSelect={songSelectHandler}
      />
    </div>
  );
}
